import React from "react";
import { BannerCopyVariant } from "../../../../../../common/service/server/dto/CMPSettingsDto";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";
import { ConsentOptionCards } from "../../../consentBanner/ConsentOptionCards";
import { BannerButtonPreview, BannerButtonRow } from "../../../consentBanner/ConsentThumbnails";

const BUTTON_OPTIONS = [
  {
    value: BannerCopyVariant.DEFAULT,
    buttons: ["Manage", "Decline", "Accept"],
    note: "Default",
  },
  {
    value: BannerCopyVariant.CUSTOMIZE_STRICTLY_NECESSARY_ACCEPT_ALL,
    buttons: ["Customize", "Strictly Necessary", "Accept All"],
  },
];

export const ConsentBannerOptInButtonTextRow = () => {
  return (
    <ConsentSettingRow
      title="Button labels"
      helpText="The buttons on the opt-in banner. Doesn't apply to the GDPR banner."
    >
      <ConsentOptionCards
        field="bannerCopyVariant"
        ariaLabel="Opt-in banner button labels"
        columns={1}
        layout="row"
        options={BUTTON_OPTIONS.map((option) => ({
          value: option.value,
          label: option.buttons.join(", "),
          note: option.note,
          preview: (
            <BannerButtonRow>
              {option.buttons.map((label, index) => (
                <BannerButtonPreview key={label} variant={index === 0 ? "link" : "button"}>
                  {label}
                </BannerButtonPreview>
              ))}
            </BannerButtonRow>
          ),
        }))}
      />
    </ConsentSettingRow>
  );
};
